import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SRMark } from "./SRMark";

export const LegalPage = ({ title, updated, children, testId }) => (
  <div className="min-h-screen bg-background" data-testid={testId}>
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-link">
          <SRMark />
          <span className="font-heading text-lg font-semibold tracking-tight text-slate-900">SimplyRefer</span>
        </Link>
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-primary" data-testid="legal-back-link">
          <ArrowLeft className="h-4 w-4" /> Back
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-3xl px-6 py-12 animate-fadein">
      <h1 className="font-heading text-3xl font-semibold tracking-tight text-slate-900">{title}</h1>
      <p className="mt-2 text-sm text-slate-400">Last updated: {updated}</p>
      <div className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed text-slate-700 [&_h2]:mt-8 [&_h2]:font-heading [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-slate-900 [&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mt-1">
        {children}
      </div>
      <p className="mt-12 border-t border-slate-200 pt-6 text-sm text-slate-500">
        Questions about this policy? Contact{" "}
        <a href="mailto:hello@simplyrefer.com.au" className="font-medium text-primary hover:underline">hello@simplyrefer.com.au</a>.
      </p>
    </main>
  </div>
);
